import { MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { getAllLocations } from "../../utils/ApiCalls/Locations";

const SelectLocation = ({disabled, getData, setStatus, status, width, setPage }) => {
    const [, dispatch] = useDataLayerValue();
    const [locationOption, setLocationOption] = useState([]);
    const [selectedValue, setSelectedValue] = useState("");
    let con = ["SG"
        , "MY"
        , "ID"
        , "IN"
        , "CN"
        , "TW"
        , "HK"
        , "PH"
        , "AE"]
    useEffect(() => {
        if (status) {
            getData(1);
            setPage(1);
        }

    }, [status]);
    useEffect(() => {
        getOptionLocation()
    }, [])
 

    const getOptionLocation = async () => {
        dispatch({
            type: "SET_LOADING",
            loading: true,
        });
        let data = await getAllLocations();
        if (data.error) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: data.error,
            });
        } else {
            setLocationOption(data?.data?.filter(item => !con.includes(item.location_code)) || []);
        }
        dispatch({
            type: "SET_LOADING",
            loading: false,
        });
    };
    return (
        <Select
            style={{ width: width || "50%", height: "40px", marginRight: "10px" }}
            required
            displayEmpty
            disabled={!disabled}
            renderValue={status ? undefined : () => "Select Location"}
            value={status}
            onChange={(e) => {
                setStatus(e.target.value)
            }}
        >
            <MenuItem  value={-1}>
                All
            </MenuItem>
            {locationOption.map((item, index) => (
                <MenuItem key={index + ""} value={item.id}>
                    {item.location_name}
                </MenuItem>
            ))}
        </Select>
    );
};



export default SelectLocation;
